import React from 'react'

import { DS } from '@/design-system'
import { useGameOptionsDrawerStore } from './GameOptionsDrawer'
import { useAVSheetStore } from '../../components/AV/useAVSheetStore'
import { translate } from '../../i18n'
import { BaseBottomSheet, Center } from './BaseBottomSheet'

/**
 * Sheet shown to non-host players while waiting for the host to start the game
 */
export const WaitingForHostSheet = () => {
  const isDrawerOpen = useGameOptionsDrawerStore((s) => s.status === 'open')
  const isAVOpen = useAVSheetStore((s) => s.isOpen)

  return (
    <BaseBottomSheet dismissOnOverlays={[isDrawerOpen, isAVOpen]}>
      <Center style={{ gap: 8 }}>
        <DS.Icon name="Clock" size={32} color="Brand/Dark Grey" />
        <DS.Text variant="Body Large/Medium" color="Brand/Dark Grey" textAlign="center">
          {translate('gameScreen.waitingForHostToStart')}
        </DS.Text>
      </Center>
    </BaseBottomSheet>
  )
}
